import { render, staticRenderFns } from "./onboarding-modal.vue?vue&type=template&id=8c56b9ae&scoped=true&"
import script from "./onboarding-modal.vue?vue&type=script&lang=ts&"
export * from "./onboarding-modal.vue?vue&type=script&lang=ts&"
import style0 from "./onboarding-modal.vue?vue&type=style&index=0&id=8c56b9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c56b9ae",
  null
  
)

export default component.exports